import React from 'react';

export default function Select({ value, onChange, options, placeholder, className = "", ...props}) {
  return (
    <select
      id="comboBox"
      value={value}
      onChange={onChange}
      className={`h-[50px] p-3 text-base w-full bg-input dark:bg-neutral-900 text-foreground dark:text-neutral-100 border-2 border-border dark:border-neutral-700 rounded-none shadow-none focus:outline-none focus:border-foreground dark:focus:border-neutral-300 transition-colors duration-150 ${className}`}
      {...props}
    >
      <option key="placeholder" value="" disabled hidden>{placeholder}</option>
      {options
        .filter(option => option.trim() !== "")
        .map(option => (
          <option key={option} value={option}>{option}</option>
        ))}
    </select>
  );
}
